import React from 'react';
import { librarianRoutes } from '../Librarian/librarianRoutes';

import AdminDashboard from './Dashboard/AdminDashboard';
import SchoolList from './Schools/SchoolList';
import RoleList from './Roles/RoleList';
import UserList from './Users/UserList';

/**
 * Admin routes.
 *
 * Every Librarian screen is reused verbatim under an `/admin/...` path (the
 * pages are already library-scoped by the top-bar selector via
 * `useActiveLibraryId`, and navigate via `useSectionBase` so they stay inside
 * `/admin`). We simply re-prefix the librarian route table.
 *
 * The librarian dashboard is excluded because the admin gets a dedicated
 * cross-library aggregate dashboard instead. Super-admin-only screens (schools,
 * roles, users) are appended.
 */
const reusedLibrarianRoutes = librarianRoutes
  .filter((r) => r.path !== '/librarian/dashboard')
  .map((r) => ({
    path: r.path.replace('/librarian', '/admin'),
    element: r.element
  }));

export const adminRoutes = [
  { path: '/admin', element: <AdminDashboard /> },
  { path: '/admin/dashboard', element: <AdminDashboard /> },

  ...reusedLibrarianRoutes,

  // Super-admin-only management screens
  { path: '/admin/schools', element: <SchoolList /> },
  { path: '/admin/roles', element: <RoleList /> },
  { path: '/admin/librarians', element: <UserList /> },
  { path: '/admin/users', element: <UserList /> }
];

export default adminRoutes;
